import { environment } from "../../../environments/environment";

export const appTraceConstantsUrl = {
  auth: {
    accessLog: environment.appSettings.apiBaseAddress + '/Profile/AuthTrace/AccessLog',
    accessLogTypeList: environment.appSettings.apiBaseAddress + '/Profile/AuthTrace/AccessLogTypeList',
    getMetadata: environment.appSettings.apiBaseAddress + '/System/Domain/CreateModel',
  },
  changeLog: {
    getChangeLogList: environment.appSettings.apiBaseAddress + '/ChangeLog/GetChangeLogList',
    getChangeLogListExcel: environment.appSettings.apiBaseAddress + '/ChangeLog/GetChangeLogListExcel',
    getDataBefore: environment.appSettings.apiBaseAddress + '/ChangeLog/GetDataBefore',
    getDataAfter: environment.appSettings.apiBaseAddress + '/ChangeLog/GetDataAfter',
    getList: environment.appSettings.apiBaseAddress + '/ChangeLog/GetList',
    getListExcel: environment.appSettings.apiBaseAddress + '/ChangeLog/GetListExcel',
    getMetadata: environment.appSettings.apiBaseAddress + '/System/Domain/CreateModel',
  },
  systemLogMessage: {
    ack: environment.appSettings.apiBaseAddress + '/System/LogMessage/Ack',
    getList: environment.appSettings.apiBaseAddress + '/System/LogMessage/GetList',
    getMetadata: environment.appSettings.apiBaseAddress + '/System/Domain/CreateModel',
    getNoAckCount: environment.appSettings.apiBaseAddress + '/System/LogMessage/GetNoAckCount',
    getSendingSystemList: environment.appSettings.apiBaseAddress + '/System/LogMessage/GetSendingSystemList',
    getTypeList: environment.appSettings.apiBaseAddress + '/System/LogMessage/GetTypeList'
  }
};
